import React from 'react'
import isNil from 'lodash/isNil'
import styles from './UploadedMeta.module.scss'
import { formatCompactDate } from './utils'

interface UploadedMetaProps {
  createdAt: string
  /** The delivery's `createdByName`. */
  uploaderName?: string | null
  /** The delivery's `createdByEmail`. */
  uploaderEmail?: string | null
}

const clean = (value?: string | null): string | null =>
  !isNil(value) && value.trim() !== '' ? value.trim() : null

/** "Name (email)", or whichever half the person actually has. */
const formatUploader = (
  name: string | null,
  email: string | null
): string | null => {
  if (name !== null && email !== null) return `${name} (${email})`
  return name ?? email
}

const UploadedMeta: React.FC<UploadedMetaProps> = ({
  createdAt,
  uploaderName,
  uploaderEmail,
}) => {
  const uploader = formatUploader(clean(uploaderName), clean(uploaderEmail))

  return (
    <span className={styles.stack}>
      <span className={styles.date}>{formatCompactDate(createdAt)}</span>
      {uploader !== null ? (
        <span className={styles.uploader}>Uploaded by: {uploader}</span>
      ) : null}
    </span>
  )
}

export { UploadedMeta }
